export const translations = {
  en: {
    home: {
      title: '6 Questions Quizzes',
      subtitle: 'Get 4 right and enter the $5,000 giveaway. 5 winners every week!',
      startButton: 'Start',
      loading: 'Loading quizzes...',
      noQuizzes: 'No quizzes available at the moment',
      error: 'Failed to load quizzes'
    },
    quiz: {
      question: 'Question',
      of: 'of',
      loading: 'Loading question...',
      nextQuestion: 'Next Question',
      finish: 'Finish Quiz'
    },
    result: {
      congratulations: "Congratulations, you're in the $5,000 giveaway",
      notEnough: 'You need at least 4 correct answers to participate',
      tryAgain: 'Try Again',
      correctAnswers: 'Correct answers',
      outOf: 'out of',
      submitting: 'Submitting your result...',
      submitted: 'Your result has been submitted!',
      submitError: 'Failed to submit result. Please try again.',
      backToHome: 'Back to Quizzes'
    },
    common: {
      retry: 'Retry',
      offline: 'You are offline. Please check your internet connection.',
      error: 'Something went wrong',
      loading: 'Loading...'
    }
  },
  ru: {
    home: {
      title: 'Квизы по 6 вопросов',
      subtitle: '4 правильных и ты участвуешь в розыгрыше $5000. 5 победителей каждую неделю!',
      startButton: 'Начать',
      loading: 'Загрузка квизов...',
      noQuizzes: 'В данный момент нет доступных квизов',
      error: 'Не удалось загрузить квизы'
    },
    quiz: {
      question: 'Вопрос',
      of: 'из',
      loading: 'Загрузка вопроса...',
      nextQuestion: 'Следующий вопрос',
      finish: 'Завершить квиз'
    },
    result: {
      congratulations: 'Поздравляем, вы участвуете в розыгрыше $5000',
      notEnough: 'Чтобы участвовать, нужно ответить правильно хотя бы на 4 вопроса',
      tryAgain: 'Пройти ещё раз',
      correctAnswers: 'Правильных ответов',
      outOf: 'из',
      submitting: 'Отправка результата...',
      submitted: 'Ваш результат отправлен!',
      submitError: 'Не удалось отправить результат. Попробуйте еще раз.',
      backToHome: 'Вернуться к квизам'
    },
    common: {
      retry: 'Повторить',
      offline: 'Вы не в сети. Проверьте подключение к интернету.',
      error: 'Что-то пошло не так',
      loading: 'Загрузка...'
    }
  }
};